export const SIZE_INPUT_ICON = 14;
export const SIZE_INPUT_ICON_SM = 11;
export const SIZE_INPUT_ICON_LG = 18;
